import { getDictPhrase } from "../../../common";
import { getSelectionTitleBulletProps } from "../../selection";
export const getSelectionTitlesListProps = (bet, state) => {
    return {
        betId: bet.betId,
        betExpandedProps: {
            expandedSelectionTitles: state.getBetExpandedProp(bet.betId, "expandedSelectionTitles")
        },
        setExpandedSelectionTitles: state.setExpandedSelectionTitles,
        selectionTitlesToShow: state.config.selectionTitlesToShow,
        selectionTitles: bet.selections.map(s => getSelectionTitleBulletProps(s, bet.type, state, bet.isEachWay)),
        phraseViewMore: getDictPhrase(state.dict, "ViewAll"),
        phraseViewLess: getDictPhrase(state.dict, "ViewLess")
    };
};
//# sourceMappingURL=getSelectionTitlesListProps.js.map